import AppDialog from './AppDialog.vue'

export default AppDialog
